import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  linkActiveClass: 'active',
  routes: [
    {
      path: '/',
      redirect: '/statistics'
    },
    {
      path: '/auth',
      name: 'Auth',
      component: () => import('@/views/Auth'),
      meta: {
        title: 'WiFi Бизнес от Уфанет | Авторизация'
      }
    },
    {
      path: '/home',
      name: 'HomeMobile',
      component: () => import('@/views/HomeMobile'),
      meta: {
        title: 'WiFi Бизнес от Уфанет | Главная'
      }
    },
    {
      path: '/statistics',
      name: 'Statistics',
      component: () => import('@/views/page_statistics/Statistics'),
      meta: {
        requiresAuth: true,
        title: 'WiFi Бизнес от Уфанет | Статистика',
        titleHeader: 'Статистика'
      }
    },
    {
      path: '/advertising',
      component: () => import('@/views/page_advertising/Advertising'),
      meta: { requiresAuth: true },
      children: [
        {
          path: '',
          name: 'AdvertisingList',
          component: () => import('@/views/page_advertising/AdvertisingList'),
          meta: {
            requiresAuth: true,
            title: 'WiFi Бизнес от Уфанет | Страница приветствия',
            titleHeader: 'Страница приветствия'
          }
        },
        {
          path: 'object/:id',
          name: 'AdvertisingBindingsByAddress',
          component: () => import('@/views/page_advertising/AdvertisingBindingsByAddress'),
          meta: {
            requiresAuth: true,
            title: 'WiFi Бизнес от Уфанет | Объект',
            titleHeader: 'Объект'
          },
          props: true
        },
        {
          path: 'tmpl-brand/:id',
          name: 'TemplateStepBase',
          component: () => import('@/views/page_template/TemplateStepBase'),
          meta: {
            requiresAuth: true,
            title: 'WiFi Бизнес от Уфанет | Шаблон страницы',
            titleHeader: 'Шаблон страницы'
          },
          props: true
        }
      ]
    },
    {
      path: '/redirect',
      name: 'Redirect',
      component: () => import('@/views/Redirect'),
      meta: {
        requiresAuth: true,
        title: 'WiFi Бизнес от Уфанет | Переадресация',
        titleHeader: 'Переадресация'
      }
    },
    {
      path: '/unloading',
      name: 'Unloading',
      component: () => import('@/views/Unloading'),
      meta: {
        requiresAuth: true,
        title: 'WiFi Бизнес от Уфанет | Выгрузка',
        titleHeader: 'Выгрузка'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js